export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updateOwners(state, value) {
    state.owners = value
  },
  updateVendors(state, value) {
    state.vendors = value
  },
  updateProducts(state, value) {
    state.products = value
  },
  updateProduct(state, value) {
    state.product = value
  },
  updateProductId(state, value) {
    state.productId = value
  },
  updateMilestonesMeta(state, value) {
    state.milestonesMeta = value
  },
  updateMilestones(state, params) {
    let obj = {}
    obj[params.id] = params.value
    state.milestones = Object.assign({}, state.milestones, obj)
  },
  resetMilestones(state) {
    state.milestones = {}
    state.milestonesMeta = null
  },
  setTaskApplicability: (state, payload) => (state.taskApplicability = payload),
  setMetaDataFields: (state, payload) => (state.metaDataFields = payload),
  setFinancialPeriods: (state, payload) => (state.financialPeriods = payload)
}
